<template>
   <div>
      <b-breadcrumb><h3>Design Details</h3></b-breadcrumb>
      <b-row >
         <b-col md="12" sm="12">
            <div class="brand-card" style="margin-top:15px;">
               <div class="col-md-12" style="margin-top:10px;margin-bottom:10px;">
                  <div class="col-md-12">Collection >>{{this.collection_title}} </div>
                  <div class="col-md-12"><h3>{{this.design_title}}</h3> </div>
                  <div class="col-md-12"> {{this.design_date}} </div>
               </div>
               <div class="col-md-12 ">
                  <b-tabs>
                     <!-- Code for Message -->
                    <b-tab title="Message"  v-if="this.message_tab">
                        <div> 
                          <div class="container-fluid h-100">
                            <div class="row justify-content-left h-100">
                              <div class="col-md-8 col-xl-8 chat">
                                <div class="card main_body">
                                  <div class="card-header msg_head" id="heading_data">
                                    <div class="d-flex bd-highlight">
                                      <div class="img_cont">
                                        <img src="../assets/images/fc.jpeg" class="rounded-circle user_img">
                                        <span class="online_icon"></span>
                                      </div>
                                      <div class="user_info main_body_icon" >
                                        <span id="vendor_name"><label>Firstcry Admin</label></span>
                                        <p>{{totalRows}} messages</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="card-body" id="chatbody">
                                    <div class="d-flex justify-content-start mb-4" >
                                      <table class="msg_body" style="width:1200px">
                                        <tbody v-for="data in messagedata">
                                        <tr  v-if="data.message_by==0">
                                          <td><div class="msg_background"><div class="admin_msg"><img src="../assets/images/fc.jpeg" class="rounded-circle user_img_msg" >{{data.message}}</div></div></td>
                                        </tr>
                                      </tr><tr v-if="data.message_by==0"><td class="msg_date"><div>{{data.message_date}}</div></td></tr>
                                        <tr  v-if="data.message_by==1">

                                          <td><div class="msg_background"><div class="vendor_msg"><img src="../assets/images/user.jpeg" class="rounded-circle user_img_msg">{{data.message}}</div></div></td>
                                        </tr>
                                        <tr v-if="data.message_by==1"><td style="float: right;" class="msg_date">{{data.message_date}}</td></tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                  <div class="card-footer msg_input msg-footer">
                                    <div class="input-group"> 
                                      <textarea id="txtName type_msg"  v-model="txtInput"  class="form-control " placeholder="Type your message..."></textarea>
                                      <div class="input-group-append">
                                        <button type="submit"  class="input-group-text send_btn  btn btn-primary" v-bind="txtInput" @click="onMessageSubmit"><i class="fa fa-send-o"></i></button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                     </b-tab>
                     <!-- Code for Message -->
                  </b-tabs>
               </div>
            </div>
         </b-col>
      </b-row>
   </div>
</template>

<script type="text/javascript">
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'

const axios = require('axios')
 
export default {
    data() {
        return {
          visible : true,
          list: [],
          customer: {},
          messagedata: [],
          selectedId: 0,
          txtInput: ''
            }
    },
     created: function () {
        // this.availablevendors();
        this.messagedisplay();
    },
    methods: {
        
        // availablevendors: function () {
        //     this.isBusy = true;
        //     axios.post(`${CONSTANTS.API_URL}/getvendorlist`,{})
        //     .then(response => {
        //       this.result = response.data;
        //       if (this.result.returnmsg === 'Successful') {
        //         this.list  = this.result.returnvalue;
        //         this.totalRows = this.result.returnvalue.length;
        //         this.isBusy = !this.isBusy;
                
        //       }else {
        //        this.list =[];
        //        this.totalRows=0;
        //         this.isBusy = !this.isBusy;
        //       }


        //     })
        //     .catch(e => {
        //       this.errors.push(e)
        //     })


        // },
        messagedisplay: function () {
          var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)

           this.vendor_id = userInfo[0].vendor_id; 
          
            const Obj={
              admin_id: this.vendor_id,
              vendor_id: 1,
              design_id: this.$route.params.id,
            } 
            
            // this.isBusy = true;
            axios.post(`${CONSTANTS.API_URL}/getmessages`,Obj)
            .then(response => {
              this.result = response.data
              if (this.result.returnmsg === 'Successful') {

                this.messagedata  = this.result.returnvalue;
                this.totalRows = this.result.returnvalue.length;
                this.isBusy = !this.isBusy;
                
              }else {

               this.messagedata =[];
               this.totalRows= 0;
               this.availablevendors();
                this.isBusy = !this.isBusy;
              }


            })
            .catch(e => {
              this.errors.push(e)
            }) 
        },

        onMessageSubmit: function (event) {
            const Obj={
              vendor_id: 1,
              admin_id: 1,
              message: this.txtInput,
              message_by: 1
            }
            // this.isBusy = true;
            axios.post(`${CONSTANTS.API_URL}/updatemessage`,Obj)
            .then(response => {
              this.result = response.data
              if (this.result.returnmsg === 'Successful') {

                this.updateddata  = this.result.returnvalue;
                this.totalRows = this.result.returnvalue.length;
                this.txtInput ='';
                this.selectedId=this.updateddata[0].vendor_id;
                this.messagedisplay(this.selectedId);
                //this.messages.push(message);
                this.isBusy = !this.isBusy;
                

            //     setTimeout(() => {
            //     message.uploaded = true
            // }, 2000)
                
              }else {
               this.updateddata =[];
               this.totalRows=0;
                this.isBusy = !this.isBusy;
              }


            })
            .catch(e => {
              this.errors.push(e)
            }) 
        },
        onClose() {
            this.visible = false;
        },
      }  
}
</script>

<style>

    /*.chat{
      margin-top: auto;
      margin-bottom: auto;
    }*/
    /*#chatbody{
      height: 400px !important;
      overflow-y: scroll;
      background-color: white !important;
      white-space: nowrap;
      position: relative;
    }
    #contacts_body{
      height: 450px !important;
      padding:  0.75rem 0 !important;
      overflow-y: scroll;
      white-space: nowrap;
      position: relative;
    }*/
   /* .msg_body{
      overflow-y: scroll;
      max-height: 500px;
      
      width: auto;
    }*/
/*    #headingdata{
      border-radius: 15px 15px 0 0 !important;
      border-bottom: 0 !important;
      height: 57px;


    }
    .main_body{
      width: 1080px !important;
    }
   .card-footer{
    border-radius: 0 0 15px 15px !important;
      border-top: 0 !important;
  }
    .container{
      align-content: center;
    }
    .search{
      border-radius: 15px 0 0 15px !important;
      background-color: white !important;
      border:0 !important;
      color:white !important;
    }
    .search:focus{
         box-shadow:none !important;
          outline:0px !important;
    }*/
    /*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
   /*   #type_msg:focus{
         box-shadow:none !important;
           outline:0px !important;
    }
    .send_btn{
      border:1 !important;
      border-color: #20a8d8;
      background-color: #4d94ff;
      cursor: pointer;
    }
    .search_btn{
      border-radius: #20a8d8 !important;
      border:0 !important;
      background-color: #20a8d8;
      cursor: pointer;
    }
    .contacts{
      list-style: none;
      padding: 0;
    }
    .contacts li{
      width: 100% !important;
      padding: 5px 10px;
      margin-bottom: 15px !important;
    }*/
 /* .active{
      background-color: white;

  }*/
   /* .chatbody{
      width: 60%;
      height: 800px;
    }*/
/*    #select_user:hover{
      text-decoration: none;
   color: #fff;
   border-radius: 20px;
   background-color: #cccccc;
    }
    #select_user:active{
      border-radius: 20px;
      background-color: #668cff;
      height: 60px
    }
    #select_user:visited{
      border-radius: 20px;
      background-color: #53c653;
    }*/
    /*.user_img{
      height: 40px;
      width: 30px;
      border:1.5px solid #f5f6fa;
    
    }
    .user_img_msg{
      height: 30px;
      width: 30px;
      border:1.5px solid #f5f6fa;
    
    }*/
/*  .img_cont{
      position: relative;
      height: 70px;
      width: 70px;
  }
  .img_cont_msg{
      height: 40px;
      width: 40px;
  }*/
/*  .online_icon{
    position: absolute;
    height: 10px;
    width:10px;
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 5em;
    border:1.5px solid white;
  }
   .icon1{
    position: absolute;
    height: 10px;
    width:10px;
    right: 300px;
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 2em;
    border:1.5px solid white;
  }
  .offline{
    background-color: #c23616 !important;
  }
  .user_info{
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 15px;
  }
  .main_body_icon{
    font-size: 16px;
    color: black;
    margin-left: 31px;
    position: fixed;
  }
  .user_info span{
    font-size: 16px;
    color: black;
    margin-right: 190px;
  }
  .user_info p{
  font-size: 9px;
  color: black;
  }
  .msg_cotainer{
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 10px;
    border-radius: 25px;
    background-color: #82ccdd;
    padding: 10px;
    position: relative;
  }
  .msg_cotainer_send{
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 10px;
    border-radius: 25px;
    background-color: #78e08f;
    padding: 10px;
    position: relative;
  }
  .msg_time{
    position: absolute;
    left: 0;
    bottom: -15px;
    color: rgba(255,255,255,0.5);
    font-size: 10px;
  }
  #vendor_name{
    font-size: 16px;
    color: black;
    font-style: normal
  }*/

/*  .msg_time_send{
    position: absolute;
    right:0;
    bottom: -15px;
    color: rgba(255,255,255,0.5);
    font-size: 10px;
  }
  .msg_head{
    position: relative;
  }
*/  /*@media(max-width: 576px){
  .contacts_card{
    margin-bottom: 15px !important;
  }
  }*/
</style>